import { DateInput, TextInput, maxLength, required } from 'react-admin';
import { StateInput } from '@/pages/Candidate/view/inputs';
import { DefaultToolbarStyled } from '@/styles/overrides';
import { path } from './constants';
import { EditAddressFormProps } from '../types';
import useController from './useController';

const FormContent = (props: EditAddressFormProps) => {
  const { handleEditAddress, isDirty, isValid } = useController(props);

  return (
    <>
      <TextInput source={path('address1')} label="Street" validate={[required(), maxLength(256)]} />
      <TextInput source={path('address2')} label="Neighborhood" validate={maxLength(256)} />
      <TextInput source={path('city')} validate={[required(), maxLength(32)]} />
      <TextInput source={path('county')} validate={maxLength(32)} />
      <StateInput label="State" include_prefix={false} source={path('state')} validate={required()} />
      <TextInput source={path('zip')} validate={[required(), maxLength(5)]} />
      <TextInput source={path('zip4')} validate={maxLength(4)} />
      <TextInput source={path('latitude')} />
      <TextInput source={path('longitude')} />
      <DateInput source={path('first_seen')} validate={required()} />
      <DateInput source={path('last_seen')} validate={required()} />

      <DefaultToolbarStyled
        disabled={!isDirty || !isValid}
        onClose={props.onClose}
        onSave={handleEditAddress}
        saveButtonLabel="Save"
      />
    </>
  );
};

export default FormContent;
